<template>
  <div>
 <!--
    A form to enter vaccinations

    Development log
        2021 - Intial development   Bruce Talbot
        04/04/2022 - prevent vaccination duplicate being notified for duplicates in earlier years
        05/05/2022 - remove patient duplicate check
        08/12/2022 - allowed changing date within the current month
 -->
    <RwvMenu />
    <div id="app">
      <div>
        <h3 class="PageHeader">Vouchers</h3>
        <table class="Pharmacy-table DisplayTable">
          <thead>
              <tr>
                <th>Pharmacy</th>
                <th>Date</th>
                <th>Voucher Code</th>
                <th>Patient</th>
                <th class="contractAttributes">Attributes</th>
                <th/>
              </tr>
            </thead>
            <tbody>
              <tr class="Vaccination-Row">
                <td class="Pharmacy-table-cell">
                  <div v-if="UserGroup === 'VoucherAdmin'">
                    <input type="text"
                      v-model="pharmacyCode"
                      placeholder="Pharmacy"
                      class= "PharmacyDescription"
                      @change="ValidatePharmacy(pharmacyCode)"
                      >
                  </div>
                <div v-else-if="UserPharmacies.length > 0">
                  <select id="pharm-select" v-model="pharmacyCode" class ="contractCustomer" @change="ValidatePharmacy(pharmacyCode)" >
                      <option v-for="pharmacy in UserPharmacies"
                        :value="pharmacy"
                        :key="pharmacy"
                        >
                        {{pharmacy}}
                      </option>
                  </select>
                </div>
                <div v-else>
                  <input type="text"
                    v-model="pharmacyCode"
                    readonly
                    class="vaccinationPharmacy PharmacyDescription">
                </div>
              </td>
<!--                                                        8/12/22 start -->
              <td class="Pharmacy-table-cell">
                <div v-if="UserGroup == 'VoucherAdmin'">
                  <input type="date"
                    v-model="vaccinationDate"

                    >
                </div>
                <div v-else>
                  <input type="date"
                    v-model="vaccinationDate"
                    :max= "vaccinationMaxDate"
                    :min = "vaccinationMinDate"
                    @change="ValidateDate(vaccinationDate)"
                    >
                </div>
              </td>
<!--                                                        8/12/22 end -->
              <td
                  class="Pharmacy-table-cell"
                  >
                  <input type="text"
                    v-model="voucherNo"
                    @change="ValidateVoucherCode(voucherNo)"
                    class="vaccinationVoucher"
                    :readonly="ValidPharmacy ? false : true">
              </td>
              <td
                class="Pharmacy-table-cell">
                <input type="text"
                  v-model="patientName"
                  placeholder="Patient Name"
                  class="vaccination-Patient"
                  :readonly="ValidPharmacy ? false : true"
                  @change="allDataEntered()" >
<!--                   @change="ValidateVoucherPatient(voucherNo, patientName)"  05/05/2022-->
                </td>
                <td
                  class="Pharmacy-table-cell">
                  <table>
                    <tr v-for="(attribute, Attrindex) in attributes" :key="Attrindex">
                      <td class="vaccination-Attributes-Label">
                        {{attribute.name}}
                      </td>
                      <td>
                        <span v-if="attribute.multiList">
                          <select v-model="AttrLabel[Attrindex]" @change="UpdateAttributeValue(AttrLabel[Attrindex], Attrindex)"
                            class="vaccination-Attributes"
                            :disabled="ValidPharmacy ? false : true">
                            <option v-for="(Value, id) in availableValues(attribute.name)" :key="id"
                              v-bind:value="Value.values[0]
                              "
                              >
                              {{Value.values[0]}}
                            </option>
                          </select>
                        </span>
                        <span v-else>
                          <input type= text @change="UpdateAttributeValue($event.target.value, Attrindex)"
                            class="vaccination-Attributes"
                            :readonly="ValidPharmacy ? false : true">
                        </span>
                      </td>
                    </tr>
                  </table>
                </td>
                <td class="Pharmacy-table-cell" v-if="!VaccinationComplete">
<!--              <button v-if="!ValidVoucher || !ValidPharmacy || !AllData || IsDuplicate" class="btnAdd btnDisabled">Save</button>  05/05/2022 -->
                  <button v-if="!ValidVoucher || !ValidPharmacy || !ValidDate || !AllData" class="btnAdd btnDisabled">Save</button>
                  <button v-else v-on:click.once="createVaccination('', pharmacyCode, voucherNo, patientName, 'new')" class="btnAdd">Save</button>
                </td>
                <td class="Pharmacy-table-cell" v-if="VaccinationComplete">
                  <span>
<!--                <button v-if="!ValidVoucher || !ValidPharmacy || !AllData || IsDuplicate" disabled class="btnAdd btnEdit btnMargin">Update</button>   05/05/2022 -->
                    <button v-if="!ValidVoucher || !ValidPharmacy || !ValidDate || !AllData" disabled class="btnAdd btnEdit btnMargin">Update</button>
                    <button v-else v-on:click="createVaccination(id, pharmacyCode, voucherNo, patientName, 'update')" class="btnAdd btnEdit btnMargin">Update</button>
                  </span>
                  <button v-on:click="newVaccination()" class="btnAdd">New</button>
                </td>
              </tr>
            </tbody>
        </table>
      </div>
      <div>
        <button class='UserName' v-on:click="displayUserInfo()"></button>
      </div>
      <div v-if="message" :class="errormessage ? 'errormessage' : 'successmessage errormessage'" >
        <table>
          <tr>
            <td>{{message}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { API } from 'aws-amplify';
import { getVoucherCode } from '../graphql/queries';
import { createVaccination } from '../graphql/mutations';
import { getPharmacyByCode} from '../graphql/queries';
import { updateVaccination} from '../graphql/mutations';
import UserInfoStore from '../app/user-info-store';
import RwvMenu from "@/components/TheMenu";
import commonFunctions from "@/components/commonFunctions";
import { additionalItemByContractId } from '../graphql/queries';
import { getPharmacyUserByUserEmail } from '../graphql/queries';
import {getVaccinationsByVoucherCodeAndPatient} from '../graphql/queries'

export default {
  name: 'app',
  components:{
    RwvMenu,
  },
  async created() {
//     console.log('created ...');

    this.getPharmacyUser(this.userEmail)
    if(UserInfoStore.state.userGroup != 'VoucherAdmin') {
      this.pharmacyCode = UserInfoStore.state.branchName
      this.ValidatePharmacy(UserInfoStore.state.branchName);
    }
    else {this.pharmacyCode =''};
    this.setDateValues();
//     console.log('created end');
    },
    data() {
      return {
        id:'',
        VoucherCode: [],
        DupVoucherCode: [],
        Pharmacys: [],
        Voucher: '',
        message: '',
        errormessage: false,
        vaccinationDate: '',
        vaccinationMaxDate: '', 
        vaccinationMinDate: '',
        pharmacyName: '',
        patientName: '',
        voucherNo: '',
        attributesReqd: false,
        attributes: [],
        attributeValues: [],
        Values: [],
        UserPharmacies: [],
        ValidVoucher: false,
        ValidPharmacy: false,
        ValidDate: true,
        isDuplicate: true,
        VaccinationComplete: false,
        AllData: false,
        UserGroup: UserInfoStore.state.userGroup,
        pharmacyCode: '',
        userEmail: UserInfoStore.state.userEmail.toLowerCase(),
        noAttributes: true,
        AttrLabel: [],
        hasValues: [],
        yearSelect: '',
      }
  },
  computed: {
    sortedAttributesValues: function() {
  //    console.log('sortedAttributes ...');
      return this.Values.slice().sort((a,b) => {
        if(a["values"] === null | a["values"] === undefined) return 1;
        if(b["values"] === null | b["values"] === undefined) return -1;
        if(a["values"] < b["values"]) return -1;
        if(a["values"] > b["values"]) return 1;
        return 0;
        });
      }
  },
  methods: {
    availableValues(attributeName) {                          // Determine valid codes for dropdown
      return (this.sortedAttributesValues.filter(attribName =>
        attribName.label === attributeName))
    },
    setDateValues (){
      //                                                        8/12/22 start
    var min_Date = new Date(), y = min_Date.getFullYear(), m = ("0" + (min_Date.getMonth() + 1)).slice(-2), d = min_Date.getDate();
    this.vaccinationMinDate = y +'-'+ m + '-01';
    this.vaccinationDate = new Date(y, m - 1,d, 23, 59, 59).toISOString().toLocaleString().slice(0, 10);
    this.vaccinationMaxDate = this.vaccinationDate;
    //                                                        8/12/22 end    
    },
    async getPharmacyUser(userEmail) {                        //get available pharmacies for user
 //      console.log('getPharmacyUser ...');
      var filter;
      filter = {enabled: {eq: true}};
      var limit = 2000;
      try {
        const User = await API.graphql({
          query: getPharmacyUserByUserEmail,
          variables: {userEmail: userEmail, filter: filter, limit: limit}
        });
        if(User.data.getPharmacyUserByUserEmail.items.length > 0) {
          for (var i=0; i < User.data.getPharmacyUserByUserEmail.items[0].pharmacyCodes.length; i++) {
            this.UserPharmacies[i] = User.data.getPharmacyUserByUserEmail.items[0].pharmacyCodes[i]
          }

          var valObj = this.UserPharmacies.includes(this.pharmacyCode)
          if (!valObj) {
            this.UserPharmacies.push(this.pharmacyCode)
          }
          this.UserPharmacies.sort();
          }
        }
      catch (error) {
        this.message = commonFunctions.displayError(error);
      }
//       console.log('getPharmacyUser end');
   },
    displayUserInfo(){
      alert("User: " + this.userEmail + " Pharmacies: " + this.UserPharmacies)
    },

    async  ValidatePharmacy(code) {                         // Validate pharmacy code
//       console.log('getPharmacys ...');
      this.ValidPharmacy = false;
      if(!code){
        this.message = "No Pharmacy code found";
        this.errormessage = true;
        return}
      try {
        this.pharmacyCode = code
        const QueryVariables = {code};
        const Pharmacys = await API.graphql({
          query: getPharmacyByCode,
          variables: QueryVariables,
        });
        this.Pharmacys = Pharmacys.data.getPharmacyByCode.items;
        if (!this.Pharmacys[0]){                                //Confirm valid Pharmacys code
          this.message = "Invalid Pharmacy entered - name is |" + code + "|";
          this.errormessage = true;
          return;
        }

        if (!this.Pharmacys[0].enabled){                                //Confirm Pharmacy enabled
          this.message = "Pharmacy is not enabled";
          this.errormessage = true;
          return;
        }
        this.ValidPharmacy = true;
        this.message = '';
        this.errormessage = false;
      }
      catch (error) {
        this.message = commonFunctions.displayError(error);
      }
 //      console.log('getPharmacys end ...')
    },

    async ValidateDate(VaccinationDate) {                       // Validate Vaccination Date
//       console.log('ValidateDate ...');
      this.ValidDate = false;
//      if (this.UserGroup != 'VoucherAdmin') {

        if (VaccinationDate < this.vaccinationMinDate) {
          this.message = "Vaccination Date must in the current month" 
          this.errormessage = true;
          return;
        }
        if (VaccinationDate > this.vaccinationMaxDate) {
          this.message = "Vaccination Date cant be greater than today"
          this.errormessage = true;
          return;
        }
//      }
      this.ValidDate = true;
      this.message = '';
      this.errormessage = false;
    },

    async ValidateVoucherCode(voucherCode) {                    // ValidateVoucherCode
  //     console.log('ValidateVoucherCode ...');
      this.ValidVoucher = false;
      this.attributes = [];
      this.attributeValues = [];
      if (!voucherCode){return}
      try {
        const QueryVariables = {voucherCode};
        const Voucher = await API.graphql({
          query: getVoucherCode,
          variables: QueryVariables,
        });
        this.VoucherCode = Voucher.data.getVoucherCode.items;
        if (!this.VoucherCode[0]){                                //Confirm valid voucher code
          this.message = "Invalid voucher code entered";
          this.errormessage = true;
          return;
        }
      }
      catch (error) {
        this.message = commonFunctions.displayError(error);
        return;
      }
      const today = new Date();
      const date =  new Date(today.getFullYear()+','+(today.getMonth()+1)+','+ today.getDate());
      const vDate = new Date(this.VoucherCode[0].voucherExpiry)
      const voucherDate =  new Date(vDate.getFullYear()+','+(vDate.getMonth()+1)+','+vDate.getDate());
      if(voucherDate < date) {                              //Confirm voucher isnt expired
        this.message = "This voucher has expired";
        this.errormessage = true;
        return;
      }
      this.message = '';
      this.errormessage = false;
      this.ValidVoucher = true;
//      this.vaccinationDate = today;

      if(this.VoucherCode[0].customerAttributes) {            //determine columns to show
        this.attributesReqd = true
        this.attributes = this.VoucherCode[0].customerAttributes
        this.allDataEntered()
      }
      this.getAttributeValues(this.VoucherCode[0].id)
//      this.ValidateVoucherPatient(voucherCode, this.patientName) 05/05/2022
//      console.log('ValidateVoucherCode end ...');
    },
    async ValidateVoucherPatient(voucherCode, patientName) {  // check if the voucher has been used by this patient before - 05/05/2022 disabled
//      console.log("ValidateVoucherPatient ...")
//      this.IsDuplicate = true;
      if (!voucherCode || !patientName || !this.ValidVoucher || !this.ValidDate){return}
      try {
        this.message = '';
        var Voucher = []
        if (!this.id) {
          Voucher = await API.graphql({
            query: getVaccinationsByVoucherCodeAndPatient,
            variables: {voucherCode: voucherCode, patientName: {eq: patientName}}
          });
        }
        else{
          var filter;
          filter = {id: {ne: this.id}};
          Voucher = await API.graphql({
            query: getVaccinationsByVoucherCodeAndPatient,
            variables: {voucherCode: voucherCode, patientName: {eq: patientName}, filter: filter}
          });
        }
        this.DupVoucherCode = Voucher.data.getVaccinationsByVoucherCodeAndPatient.items;
                                                         // 05/04/2022 start        
                                                        // 04/04/2022 start
        const today = new Date();
        var dupDate;
        for(var i=this.DupVoucherCode.length - 1; i>=0; i--) {
          dupDate = new Date(this.DupVoucherCode[i].vaccinationDate)
 //         console.log(this.DupVoucherCode[i].vaccinationDate)
          if (today.getFullYear() <= dupDate.getFullYear()){
                                                        // 04/04/2022 end
            var str = new Date(this.DupVoucherCode[0].vaccinationDate);
            str = ((str.getDate() < 10) ? '0' : '') + str.getDate()+ '-' + ((str.getMonth() < 9) ? '0' : '') + (str.getMonth() + 1) + '-'
            + str.getFullYear() + ' ' + ((str.getHours() < 10) ? '0' : '') + str.getHours() + ":" + ((str.getMinutes() < 10) ? '0' : '') + str.getMinutes();
            this.message = "This voucher was used by the same patient (" + patientName + ") at " + this.DupVoucherCode[0].pharmacyCode + " on " + str ;
            this.errormessage = true;
            this.IsDuplicate = true;
            return
          } 
        }
                                                          // 05/04/2022 end        
        this.IsDuplicate = false;
      }
      catch (error) {
        this.message = commonFunctions.displayError(error);
        return;
      }
      this.allDataEntered()
 //     console.log("ValidateVoucherPatient end")
    },

    async createVaccination(id, pharmacyCode, voucherCode, patientName, UpdateType){      // Create Vaccination record
//       console.log('createVaccination ...');
      if (!pharmacyCode || !voucherCode || !patientName || !this.ValidVoucher || !this.ValidDate) return;
      const currentTime = new Date()
      const vacDate = new Date(this.vaccinationDate);
      var today = new Date();
      if(this.vaccinationDate == this.vaccinationMaxDate){                              // current time if date hasnt been changed
        today = new Date(vacDate.getFullYear(), vacDate.getMonth(), vacDate.getDate(), currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      }
      else {
        today = new Date(vacDate.getFullYear(), vacDate.getMonth(), vacDate.getDate(), 12, 0, 0); // midday if date is changed
      }
      const vaccinationDate = today
      const vaccinationYearMonth = today.getFullYear() + ((today.getMonth() < 9) ? '0' : '') + (today.getMonth() + 1);
      var i;
      if (!commonFunctions.xssTest(pharmacyCode)) {
        this.message = commonFunctions.xssMessage("Pharmacy")
        this.errormessage = true;
        return
      }
      if (!commonFunctions.xssTest(voucherCode)) {
        this.message = commonFunctions.xssMessage("Voucher")
        this.errormessage = true;
        return
      }
      if (!commonFunctions.xssTest(patientName)) {
        this.message = commonFunctions.xssMessage("Patient Name")
        this.errormessage = true;
        return
      }
      var UpdateValues;
      var customerAttributes = [];
      for(i=0; i < this.attributes.length; i++) {
          customerAttributes.push({
          name: this.attributes[i].name,
          value: this.attributeValues[i]
        });
      }
      const contractId = this.VoucherCode[0].id;
      const lastUpdatedBy = this.userEmail;
      var chargeTo = this.VoucherCode[0].customer.chargeTo;

      try {
        if (UpdateType === "new") {
          UpdateValues = {contractId, patientName, pharmacyCode, voucherCode, vaccinationDate, customerAttributes, lastUpdatedBy, chargeTo, vaccinationYearMonth};
          const VaccinationId = await API.graphql({
             query: createVaccination,
             variables: {input: UpdateValues},
           });
           this.message = "This vaccination record has been recorded";
           this.errormessage = false;
           this.id = VaccinationId.data.createVaccination.id;
        }
        else {
          UpdateValues = {id, contractId, patientName, pharmacyCode, voucherCode, customerAttributes, lastUpdatedBy, chargeTo};
          await API.graphql({
             query: updateVaccination,
             variables: {input: UpdateValues},
           });
           this.message = "This vaccination record has been updated";
           this.errormessage = false;
         }
         this.VaccinationComplete = true;
       }
       catch (error) {
          this.message = commonFunctions.displayError(error);
       }
//       console.log('createVaccination end');
    },

  UpdateAttributeValue(AttrValue, Attrindex) {
//       console.log('UpdateAttributeValue ...');
      this.attributeValues[Attrindex] = AttrValue;
      this.allDataEntered()
//       console.log('UpdateAttributeValue end');
    },

    newVaccination() {
      this.attributesReqd = false;
      this.attributes = [];
      this.attributeValues = [];
      this.AttrLabel = [];
      this.ValidVoucher = false;
      this.VoucherCode = [];
      this.Pharmacys = [];
      this.Voucher = '';
      this.setDateValues();
      this.patientName = '';
      this.voucherNo = '';
      this.message = "";
      this.VaccinationComplete = false;
      this.errormessage = false;
    },

    allDataEntered(){                                                   // Check all data has been entered
//       console.log ("allDataEntered ...");
      this.AllData = true;
      var i;
      for(i=0; i < this.attributes.length; i++) {
        if(!this.attributeValues[i]){
          this.AllData = false;
          continue;
        }
        if (!commonFunctions.xssTest(this.attributeValues[i])) {
          this.message = commonFunctions.xssMessage(this.attributes[i].name)
          this.errormessage = true;
          this.AllData = false;
          return;
        }
      }
      if (!this.AllData){return}
      if (!this.patientName || this.IsDuplicate){
        this.AllData = false;
        return}
      else {
        this.AllData = true;}

      if (!commonFunctions.xssTest(this.patientName)) {
        this.message = commonFunctions.xssMessage("Patient Name")
        this.errormessage = true;
        this.AllData = false;
      }
      else {
        this.message = '';
        this.errormessage = false;
      }
//      console.log ("allDataEntered end");
    },
    async getAttributeValues(contractId) {
 //      console.log("getAttributeValues ...")
      try {
        var limit = 1000;
        const QueryVariables = {contractId, limit};
        const attributeValues = await API.graphql({
          query: additionalItemByContractId,
          variables: QueryVariables
        });
        this.Values = attributeValues.data.additionalItemByContractId.items;
      }
      catch (error) {
        this.message = commonFunctions.displayError(error);
      }

 //     console.log('getAttributeValues end ...')
    },
  }
}
</script>
<style>

</style>
